var map = {
	"./logo_facebook.png": 487,
	"./logo_github.png": 488,
	"./logo_hatena.png": 489,
	"./logo_instagram.png": 490,
	"./logo_qiita.png": 491,
	"./logo_twitter.png": 492,
	"./logo_wantedly.png": 493,
	"./logo_youtube.png": 494
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 486;